// extracted by mini-css-extract-plugin
module.exports = {"saytItemText":"SaytItemText_saytItemText__L_Ypn","saytMisoAutoSuggest":"SaytItemText_saytMisoAutoSuggest__JTr5v"};